import CompanyDetailsFormFields, {
  type CompanyDetailsFormValues, getInitialValuesFromKeyValuesObj, defaultCompanyDetailsFormInitialValues
} from './CompanyDetailsFormFields';

export default CompanyDetailsFormFields;
export { type CompanyDetailsFormValues, getInitialValuesFromKeyValuesObj, defaultCompanyDetailsFormInitialValues };
